import * as actionType from './ActionType';

export const setStep04 = (data) => ({
  type: actionType.SET_VALUE_STEP04,
  payload: data
});
